/** First-analysis celebration shown once when a user activates. */
import React from 'react';
import { Modal, View } from 'react-native';
import { MaterialIcons } from '@expo/vector-icons';

import { Button } from '@/components/ui/button';
import { Text } from '@/components/ui/text';
import { useTranslation } from '../../../hooks/useTranslation';
import { COLORS } from '../chatConstants';

export function ActivationCelebration({ visible, isPhone, onDismiss }: { visible: boolean; isPhone: boolean; onDismiss: () => void }) {
  const { t } = useTranslation();
  return (
    <Modal
      visible={visible}
      animationType="fade"
      transparent
      onRequestClose={onDismiss}
    >
      <View
        style={{
          flex: 1,
          alignItems: 'center',
          justifyContent: 'center',
          padding: isPhone ? 18 : 32,
          backgroundColor: 'rgba(15, 23, 42, 0.72)',
        }}
      >
        <View
          style={{
            width: '100%',
            maxWidth: 560,
            borderRadius: 24,
            backgroundColor: COLORS.background,
            padding: isPhone ? 24 : 36,
            alignItems: 'center',
            gap: 16,
          }}
        >
          <View
            style={{
              width: 72,
              height: 72,
              borderRadius: 36,
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: '#ECFDF5',
            }}
          >
            <MaterialIcons name="celebration" size={38} color={COLORS.success} />
          </View>
          <Text
            selectable
            style={{
              color: COLORS.text.primary,
              fontSize: isPhone ? 25 : 30,
              lineHeight: isPhone ? 31 : 37,
              fontWeight: '900',
              textAlign: 'center',
            }}
          >
            {t('chat.activationCelebrationTitle')}
          </Text>
          <Text
            selectable
            style={{
              color: COLORS.text.secondary,
              fontSize: 15,
              lineHeight: 23,
              textAlign: 'center',
            }}
          >
            {t('chat.activationCelebrationBody')}
          </Text>
          <Button
            variant="default"
            size="default"
            onPress={onDismiss}
            style={{ width: '100%' }}
          >
            <Text className="text-white font-semibold">
              {t('chat.activationCelebrationCta')}
            </Text>
          </Button>
        </View>
      </View>
    </Modal>
  );
}
